import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Servicio } from 'src/app/models/Servicio/Servicio';
import { LocalStorageService } from 'src/app/services/local-storage.service';

@Component({
  selector: 'app-servicios-entry',
  templateUrl: './servicios-entry.component.html',
  styleUrls: ['./servicios-entry.component.scss']
})
export class ServiciosEntryComponent implements OnInit {
  public serviceForm: FormGroup;
  private serviceObj: Servicio = new Servicio();
  @Input() public editMode: boolean = false;
  @Input() public detailMode: boolean = false;
  @Input() public serviceToEdit: Servicio = undefined;
  @Output() private sendCloseRequestEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() private sendServiceRequest: EventEmitter<any> = new EventEmitter<any>();
  constructor(private formBuilder: FormBuilder, private ref: ChangeDetectorRef, private localStorage: LocalStorageService) { }

  ngOnInit(): void {
    this.setServiceForm();
    if (this.serviceToEdit) {
        this.setServiceDataToForm(this.serviceToEdit);
    }
  }
  onSubmit() {
    if (this.serviceForm.valid) {
        this.getFormData();
        this.sendServiceRequest.emit(this.serviceObj);
    }
  }
  getFormData() {
    this.serviceObj.nombre = this.serviceForm.controls.nombre.value;
    this.serviceObj.precio = this.serviceForm.controls.precio.value;
    this.serviceObj.exento = this.serviceForm.controls.exento.value ? this.serviceForm.controls.exento.value : false;
    this.serviceObj.servicioId = this.serviceToEdit ? this.serviceToEdit.servicioId : "";
    this.serviceObj.emisorId = this.serviceToEdit ? this.serviceToEdit.emisorId : undefined;
    this.serviceObj.sucursalId = this.serviceToEdit ? this.serviceToEdit.sucursalId : undefined;
    this.serviceObj.activo = this.serviceToEdit ? this.serviceToEdit.activo : true;
  }
  setServiceForm() {
    this.serviceForm = this.formBuilder.group({
        nombre: ["", Validators.required],
        precio: [, Validators.required],
        exento: [false],
    });
  }
  setServiceDataToForm(receivedService: Servicio) {
    this.serviceForm.patchValue(receivedService);
  }
  sendCloseRequest() {
    this.sendCloseRequestEmitter.emit();
  }

}
